export default "__VITE_ASSET__CiFH2slX__"